import AbsenceModeList from "./list";


if (document.body.getAttribute("data-current-path") === "teams/absence_modes") {
    const action = document.body.getAttribute("data-current-action")
    if (action === "index") {
        new AbsenceModeList();
    }
}